var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/Azure/Subscription@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.9762325%",
    y1: "7.4114724%",
    x2: "37.1841038%",
    y2: "103.76182%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0669BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.7237125%",
    y1: "52.3127289%",
    x2: "52.6927812%",
    y2: "54.8636556%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.2,
    offset: "7.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.1,
    offset: "32.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.05,
    offset: "62.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.2725685%",
    y1: "4.60005789%",
    x2: "62.4796378%",
    y2: "99.9794963%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2892DF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/Azure/Subscription",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F1F4FB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92521379,23.9556341 C8.43069096,23.7852492 7.03653841,22.7859692 6.39895327,21.4281315 C6.04721728,20.6790495 5.91352014,19.6825496 6.05642899,18.8751285 C6.36304299,17.1427947 7.63750925,15.7844004 9.37672237,15.3361801 C9.92149893,15.1957858 10.7682695,15.1797638 11.3250141,15.2993212 C11.9552606,15.4346593 11.8936952,15.4553942 12.0600372,15.0517919 C12.3943775,14.2405856 12.8989915,13.5173751 13.5767549,12.8780443 C15.3036889,11.2490294 17.689086,10.68243 19.9884505,11.355082 C20.2594779,11.4343663 20.9612622,11.7120718 21.0087979,11.7588451 C21.0202065,11.7700708 20.1148656,12.6812406 18.9968979,13.7836416 C16.7857534,15.964007 16.8643468,15.8713107 16.4223417,16.8201126 C16.1300151,17.447624 16.076112,17.5949485 15.9005803,18.2461636 C15.7204726,18.9143686 15.7028223,19.2016174 15.8254691,19.4687064 C15.982986,19.81174 16.3565428,20.0548408 16.7261428,20.0548408 C16.9512468,20.0548408 18.0503637,19.7713803 18.4875917,19.6005656 C18.7011771,19.517125 19.1186334,19.3342991 19.4152751,19.1942914 L19.9546271,18.9397299 L21.9926002,16.9406719 C23.2322122,15.7247315 24.0452599,14.9577102 24.0680644,14.9827034 C24.1921161,15.1186693 24.4524924,15.9837245 24.5532556,16.5946727 C24.6564513,17.2203565 24.590335,18.4670792 24.4243544,19.0252826 L24.3833276,19.1632648 L24.6586544,19.1632648 C25.0535827,19.1632648 25.3409058,19.2321585 25.752529,19.4255512 C27.0390104,20.0299806 27.5123718,21.6116934 26.7683444,22.819847 C26.5658344,23.1486861 26.0978693,23.5707628 25.754135,23.7346072 C25.1611816,24.017242 25.5801087,24.0038393 17.5293691,23.9977502 C13.5236877,23.9946578 10.1018172,23.9757629 9.92521379,23.9556341 L9.92521379,23.9556341 Z M16.6192825,19.1972199 C16.5439923,19.1231371 16.5545208,18.99673 16.6762845,18.5128785 C16.8181531,17.9491582 16.845892,17.8895728 16.9664708,17.8895728 C17.0820714,17.8895728 17.9482428,18.7190431 17.9482428,18.8297467 C17.9482428,18.9425687 17.8632505,18.9811347 17.3137974,19.1176263 C16.7219754,19.2646416 16.6913671,19.2681484 16.6192825,19.1972199 L16.6192825,19.1972199 Z M18.3485894,17.4956437 C17.5902211,16.7494377 17.5167631,16.6642406 17.5167631,16.5309063 C17.5167631,16.3937622 17.7323694,16.1722528 20.9793933,12.9734867 C22.8838422,11.0973446 24.4963919,9.53399788 24.5628381,9.49938095 C24.6314467,9.46363528 24.7246701,9.44835547 24.7785796,9.46401565 C24.8307887,9.4791996 25.2375687,9.84775514 25.6825313,10.2830644 C26.426741,11.0111239 26.4915593,11.0865024 26.4915593,11.2239032 C26.4915593,11.3652407 26.3019193,11.5598148 22.9635859,14.8437007 C19.8793054,17.8776792 19.4195651,18.3141327 19.3080157,18.3141327 C19.1998322,18.3141327 19.0538779,18.1896212 18.3485894,17.4956437 L18.3485894,17.4956437 Z M26.1603995,9.81199091 C25.1683221,8.83924414 25.1765784,8.85783288 25.5718713,8.48706623 C25.9273033,8.15368735 26.1808093,8.03028608 26.559357,8.00638141 C26.8255381,7.98958939 26.9035533,8.00192828 27.1016067,8.09222793 C27.4409567,8.24695266 27.7173427,8.50905667 27.8764152,8.82699493 C28.0013847,9.07677551 28.0113852,9.12680213 27.9926915,9.40853085 C27.9670144,9.79549886 27.8705161,9.98627851 27.5161118,10.3507829 C27.1094764,10.7690095 27.1548027,10.787023 26.1603995,9.81199091 L26.1603995,9.81199091 Z",
    id: "Shape",
    fill: "#658BD3",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/18px/Amazon/Color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.7427, 21.5386)",
    id: "azure"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14851413,0.000107304529 L5.94320907,0.000107304529 L3.04204138,8.59380512 C2.98090095,8.77487422 2.81106292,8.89683312 2.61990699,8.89683312 L0.444943546,8.89683312 C0.301643642,8.89683312 0.167108917,8.82785723 0.0835239203,8.71148873 C-6.10768296e-05,8.59512022 -0.0224617556,8.44562453 0.0233458143,8.30987734 L2.72627241,0.303135295 C2.78738848,0.121986417 2.95729037,0 3.14851413,0 L3.14851413,0.000107304529 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20961224,5.76418457 L2.77789881,5.76418457 C2.69358223,5.76409147 2.61779822,5.8155943 2.58686426,5.8940118 C2.5559303,5.97242931 2.57614911,6.06178415 2.63783134,6.11925538 L5.48554799,8.77654474 C5.56845912,8.85386722 5.67762878,8.89683312 5.79101315,8.89683312 L8.30042123,8.89683312 L7.20961224,5.76418457 Z",
    id: "Path",
    fill: "#0078D4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14851413,0.00010402031 C2.95501254,-0.000635074497 2.78352507,0.124545964 2.72530643,0.309037044 L0.0266730877,8.30258063 C-0.0222326534,8.43886588 -0.0016364072,8.5904278 0.0818658777,8.7087287 C0.165368163,8.82702959 0.301298125,8.89722435 0.446124191,8.89683474 L2.67722196,8.89683474 C2.84639467,8.86661435 2.98621907,8.74773187 3.04322203,8.58564998 L3.58138166,7.00001095 L5.503687,8.79253311 C5.58424228,8.85914778 5.68529465,8.89598135 5.7898325,8.89683474 L8.28990276,8.89683474 L7.19340519,5.76418469 L3.99696883,5.76493582 L5.95329822,0.00010402031 L3.14851413,0.00010402031 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71803443,0.302706077 C6.65700464,0.121849003 6.48735631,0.000107304529 6.2964367,0.000107304529 L3.18178686,0.000107304529 C3.37269584,0.000107304529 3.54232688,0.121869652 3.60338459,0.302706077 L6.30641852,8.30977004 C6.35226066,8.44554204 6.32988048,8.59507767 6.24629549,8.71148872 C6.16271049,8.82789977 6.02815526,8.89694042 5.88482079,8.89694042 L8.99957796,8.89694042 C9.1428935,8.89694042 9.27741671,8.82785091 9.36097663,8.71144515 C9.44453654,8.5950394 9.46690445,8.44552411 9.42106836,8.30977004 L6.71803443,0.302706077 Z",
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription2X);
export default __webpack_public_path__ + "static/media/Subscription@2x.ea3ceef70e435d2cf5f8292469bced38.svg";
export { ForwardRef as ReactComponent };